import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert, Stack } from '@mui/material';
import { authApi } from './api';
import { useAuthStore } from './store';

export function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('admin@local');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const res = await authApi.login(email, password);
      if (res.step === 'COMPLETE' && res.accessToken && res.refreshToken && res.user) {
        useAuthStore.getState().setSession(res.accessToken, res.refreshToken, res.user);
        nav('/dashboard');
      } else if (res.mfaToken) {
        sessionStorage.setItem('mfa-token', res.mfaToken);
        sessionStorage.setItem('mfa-step', res.step);
        nav('/login/mfa');
      }
    } catch (e: unknown) {
      const ax = e as { response?: { data?: { message?: string } } };
      setErr(ax.response?.data?.message || 'Error de login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Paper sx={{ p: 4, width: 360, maxWidth: '92vw' }} component="form" onSubmit={submit}>
        <Typography variant="h5" gutterBottom>Flotillas</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Inicia sesión</Typography>
        <Stack spacing={2}>
          {err && <Alert severity="error">{err}</Alert>}
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth autoFocus />
          <TextField label="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required fullWidth />
          <Button type="submit" variant="contained" disabled={loading} size="large">{loading ? 'Iniciando...' : 'Continuar'}</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
